import { Str } from '.';
export class Media {
/**
 * @param {?} url
 * @return {?}
 */
public static getImageType(url: string): string {
    let /** @type {?} */ matches = url.match(
      /((\.png)|(\.jpg)|(\.jpeg)|(\.gif)){1}$/);
    return !matches || matches.length == 0 ? 
      null : `image/${matches[0].replace('.', '')}`;
  }
/**
 * @param {?} type
 * @return {?}
 */
public static isAudioType(type: string): boolean {
    return [
      'audio/wav', 
      'audio/mpeg', 
      'audio/ogg'
    ].indexOf(type) > -1;
  }
/**
 * @param {?} dataUrl
 * @param {?} mimeType
 * @return {?}
 */
public static dataUrlToBlob(dataUrl: string, mimeType: string): Blob {
    const /** @type {?} */ binary = atob(dataUrl.split(',')[1]);
    let /** @type {?} */ array = [];
    for (let /** @type {?} */ i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    return new Blob([new Uint8Array(array)], {type: mimeType});
  }
/**
 * @param {?} imageUrl
 * @param {?} mimeType
 * @param {?=} imageName
 * @return {?}
 */
public static dataUrlToFile(imageUrl: string, mimeType: string, imageName?: string): File {
    let /** @type {?} */ blob = Media.dataUrlToBlob(imageUrl, mimeType);
    let /** @type {?} */ photoId = Str.isEmptyString(imageName) ? `photo-${Date.now()}` : imageName;
    return new File([blob], photoId, {type: mimeType});
  }
}
